/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _constant = _interopDefault(require('lodash/fp/constant'));
var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var Point = __ol.geom.Point;
var props = {
  coordinates: {
    type: Array,
    required: true,
    validator: function validator(value) {
      return value.length === 2;
    }
  }
};

var computed = {
  type: _constant(core.GEOMETRY_TYPE.POINT)
};

var methods = {
  /**
   * @return {ol.geom.Point}
   * @protected
   */
  createGeometry: function createGeometry() {
    return new Point(this.fromLonLat(this.coordinates));
  }
};

var Geom = {
  name: 'vl-geom-point',
  mixins: [core.geometry],
  props: props,
  computed: computed,
  methods: methods
};

var index = {
  Geom: Geom,
  install: function install(Vue) {
    Vue.component(Geom.name, Geom);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/point-geom/index.js
// module id = 1192
// module chunks = 1